import "./Document.css";
import config from "../../config";

const Document = (props) => {
  return (
    <a
      href={`${config.api}${props.fileUrl}`}
      download={props.name}
      className="col-10 col-md-6 col-lg-4 m-3 document-link"
    >
      <div className="document d-flex align-items-center ">
        <img
          src="/images/document.svg"
          alt="dokument"
          className="document-icon"
        />
        <div className="heading flex-fill">
          {props.name}
          <br />
          {props.category !== undefined ? <i> {props.category}</i> : ""}
        </div>
        <img
          src="/images/download.svg"
          alt="stáhnout"
          className="document-icon"
        />
      </div>
    </a>
  );
};
export default Document;
